import React, { useCallback, useState, useEffect } from 'react';
import __, { __route } from 'localisation';
import { Columns, Column } from 'components/Columns';
import Heading from 'components/Heading';
import Icon from '@hubins/components/IconNew';
import ProgressBar from 'components/ProgressBar';
import Button, { ButtonWrap } from '@hubins/components/Button';
import { useCollapse } from 'react-collapsed';
import Slider from '@hubins/components/Slider';
import AddSource from 'modules/AddSource';
import { getMoney } from 'helpers';
import './index.scss';

import middleman from 'helpers/middleman';

const SourceCard = ({
  source,
  index,
  callback,
  deleteSource,
  value,
  max,
  premium,
  portfolioUuid
}) => {

  const [isExpanded, setIsExpanded] = useState(false);

  const handleClick = () => {
    setIsExpanded(true);
  };

  const handleValueChange = useCallback((val) => {
    if (val > max) {
      callback(index, max);
      return;
    }

    callback(index, val);
  }, [max, value, index]);

  const { getCollapseProps, getToggleProps } = useCollapse({
    isExpanded: isExpanded }
  );

  return (
    <Column xs="12" s="6" m="6" l="4" className="source-card" align="start">
      <div className='source-card__header'>
        <Heading size="5" className="flex-center--horizontal">
          <Icon icon="Common File Stack by Streamlinehq" size={16} /> {__(`sof_${source.type}`)}
        </Heading>
        {(!source.proof_provided && source.used_amount === 0) && (
          <div className='source-card__icons'>
            <Button
              onlyIcon
              small
              href={`${__route("sof")}/${portfolioUuid}/${source.type}/premium/${source.uuid}`}>
              <Icon icon="Cog" size={16} />
            </Button>
            <Button
              onlyIcon
              small
              onClick={() => {
                deleteSource(index);
              }}
            >
              <Icon icon="Bin by Streamlinehq" size={16} />
            </Button>
          </div>
        )}
      </div>

      <p>{source.name ? source.name : ''}</p>

      <div className='source-card__status link'>
        {(source.proof_provided && source.verified_at)
          ? __('proof_verified')
          : source.proof_provided
            ? __('proof_provided')
            : __('proof_not_provided')
        }
      </div>
      <div className='source-card__content'>
        <div className='source-card__info'>
          <ul className='source-card__list'>
            <li>
              <span className='body-small clarification'>TOTALT:</span>
              <span><strong>{getMoney(source.realised_amount)}</strong></span>
            </li>
            <li>
              <span className='body-small clarification'>ANVÄNT:</span>
              <span>{getMoney(source.used_amount)}</span>
            </li>
          </ul>
        </div>
        <ProgressBar progress={(source.used_amount / source.realised_amount) * 100} />
        <ButtonWrap pushtosides>
          {premium && (
            <Button
              {...getToggleProps({ onClick: handleClick })}
              small
              className="secondary spacing"
            >
              Välj källa
            </Button>
          )}
          {!source.proof_provided && (
            <Button
              small
              href={`${__route('sofdoc')}/${source.portfolio_uuid}/${source.uuid}${premium ? '/premium' : ''}`}
              className="spacing link"
            >
                Bevisa källa
            </Button>
          )}
        </ButtonWrap>
        {premium && (
          <div className='source-card__more' {...getCollapseProps()}>
            {/* <InputCurrency
              value={value}
              onChange={(val) => { handleValueChange(false, val); }}
              max={source.realised_amount - source.used_amount}
              suffix="SEK"
            /> */}
            <Slider
              singleValue
              value={value}
              min={0}
              max={source.realised_amount - source.used_amount}
              interval={(source.realised_amount - source.used_amount) / 100}
              onChange={handleValueChange}
              suffix="SEK"
              controlled
            />
          </div>
        )}
      </div>
    </Column>
  );
};



const SourceCards = ({
  totalAmount,
  sourceAmounts,
  sources,
  setSources,
  setSourceAmounts,
  premium,
  portfolioUuid,
}) => {

  const [deletedIndex, setDeletedIndex] = useState(false);

  const handleSumChange = useCallback((index, value) => {
    const newSourceAmount = [...sourceAmounts];
    newSourceAmount[index] = value;
    setSourceAmounts(newSourceAmount);
  }, [sourceAmounts, totalAmount]);

  const syncSources = (index) => {
    const newSources = [...sources.map((item) => { return { ...item }; })];
    const newSourceAmounts = [...sourceAmounts];
    newSources.splice(index, 1);
    newSourceAmounts.splice(index, 1);
    setSources(newSources);
    setSourceAmounts(newSourceAmounts);
  };

  const deleteSource = async (index) => {
    const sourceToDelete = sources[index];
    await middleman.promiseDelete(`/source-of-funds/${sourceToDelete.portfolio_uuid}/${sourceToDelete.uuid}/delete`);
    setDeletedIndex(index);
  };

  useEffect(() => {
    if (deletedIndex !== false) {
      syncSources(deletedIndex);
      setDeletedIndex(false);
    }
  }, [deletedIndex]);


  return (
    <Columns className="source-cards">
      {sources.map((source, index) => {
        const selectedWithoutSelf = sourceAmounts.reduce((sum, item, itemIndex) => {
          if (itemIndex === index) return sum;
          sum += item;
          return sum;
        }, 0);
        const max = totalAmount - selectedWithoutSelf;
        return (
          <SourceCard
            key={`sourcecard-${index}`}
            source={source}
            index={index}
            callback={handleSumChange}
            value={sourceAmounts[index]}
            deleteSource={deleteSource}
            max={max}
            premium={premium}
            portfolioUuid={portfolioUuid}
          />
        );})}
      <Column xs="12" s="6" m="6" l="4">
        <AddSource premium={premium} portfolioUuid={portfolioUuid} />
      </Column>
    </Columns>
  );
};

SourceCards.defaultProps = {
  sourceAmounts: [],
};

export default SourceCards;
